import React, { useEffect, useState } from "react";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import MagreachIcon from "../icons/MagreachIcon";
import Button from "../ui/Button";
import Container from "./Container";
import LanguageSwitcher from "./LanguageSwitcher";
import ThemeToggle from "./ThemeToggle";
import { useI18n } from "../../i18n/I18nProvider";

const Header = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t } = useI18n();
  const links = [
    { name: t("nav.calendar"), href: "#calendar" },
    { name: t("nav.rates"), href: "#rates" },
    { name: t("nav.desks"), href: "#desks" },
    { name: t("nav.faq"), href: "#faq" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-paper/80 backdrop-blur-[30px] ${
        scrolled ? "border-b border-transparent" : "border-b border-hairline"
      }`}
    >
      <Container className="flex h-20 items-center justify-between gap-4">
        <a
          href="#top"
          className="flex shrink-0 items-center gap-2 text-ink no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          <MagreachIcon width={32} height={32} />
          <span className="text-subheading font-semibold tracking-wide">
            {t("brand")}
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" aria-label={t("nav.product")}>
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-body font-medium text-mid-gray no-underline transition-colors hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
            >
              {link.name}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          {data?.avatar?.value ? (
            <img
              src={data.avatar.value}
              alt=""
              className="hidden h-8 w-8 rounded-full object-cover md:block"
            />
          ) : null}
          <LanguageSwitcher />
          <ThemeToggle />
          <Button href="https://me.influ8.app" className="hidden sm:inline-flex">
            {t("nav.login")}
          </Button>
          <button
            type="button"
            className="inline-flex h-11 w-11 items-center justify-center rounded-pill bg-canvas text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent lg:hidden"
            onClick={() => setOpen((value) => !value)}
            aria-expanded={open}
            aria-label={open ? t("nav.closeMenu") : t("nav.openMenu")}
          >
            {open ? <HiOutlineX size={20} /> : <HiOutlineMenu size={20} />}
          </button>
        </div>
      </Container>

      {open ? (
        <div className="border-t border-hairline bg-paper lg:hidden">
          <Container className="flex flex-col gap-1 py-3">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="flex min-h-11 items-center text-body font-medium text-ink no-underline"
                onClick={() => setOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <Button href="https://me.influ8.app" className="mt-2 sm:hidden">
              {t("nav.login")}
            </Button>
          </Container>
        </div>
      ) : null}
    </header>
  );
};

export default Header;
